// Lëtzebuergescht Fragment „divers“: Iwwer eis, Kontakt, Clientsmeenungen,
// Cookie-Banner. Déiselwecht Schlësselen ewéi fr/divers.js, Wäerter op
// Lëtzebuergesch.
export default {
  // ---- Iwwer eis (pages/About.jsx) ----
  'apropos.seo.titre': 'Iwwer eis',
  'apropos.seo.description': 'Entdeckt d’Geschicht vu Mirum Games an eis Passioun, mat Joyful Reveal magesch Momenter an der Famill ze schafen — d’Puzzle aus héichwäertege Materialien.',
  'apropos.hero.badge': '🎮 Eis Geschicht',
  'apropos.hero.titre': 'Wëllkomm bei Mirum Games',
  'apropos.hero.texte': 'Mir schafe magesch Momenter, fir d’Ukomme vun Ärem Bëbee ze feieren an dës Freed an der Famill ze deelen.',
  'apropos.mission.titre': 'Eis Missioun',
  'apropos.mission.texte1': 'Bei Mirum Games gleewe mir, datt déi wichteg Momenter am Liewen et verdéngen, op eng eenzegaarteg an onvergiesslech Manéier gefeiert ze ginn. Eis Missioun ass et, festlech an interaktiv Erliefnesser ze schafen, déi aus der Uskënnegung vum Geschlecht vum Bëbee en onvergiessleche Moment vum Zesummesi mat der Famill maachen.',
  'apropos.mission.texte2': 'All Puzzle ass mat Suergfalt entworf, fir e Moment vu Spannung a Freed ze schafen, mat enger aussergewéinlecher Qualitéit an engem Erliefnes, dat der ganzer Famill an Erënnerung bleift.',
  'apropos.mission.encart.titre': 'Spillerescht Feieren',
  'apropos.mission.encart.texte': 'Aus der Uskënnegung e lëschtegt Fro-Äntwert-Spill maachen, bei deem jidderee matmécht',
  'apropos.mission.carte1.titre': 'Spannung',
  'apropos.mission.carte1.texte': 'E Moment vu Spannung an Erwaardung schafen, deen ee sech mierkt',
  'apropos.mission.carte2.titre': 'Feier',
  'apropos.mission.carte2.texte': 'Aus der Uskënnegung e festlechen an onvergiessleche Moment maachen',
  'apropos.mission.carte3.titre': 'Deelen',
  'apropos.mission.carte3.texte': 'Wäertvoll Momenter an der Famill',
  'apropos.valeurs.titre': 'Eis Grondwäerter',
  'apropos.valeurs.soustitre': 'D’Prinzipien, déi all eis Entscheedunge leeden',
  'apropos.valeurs.excellence.titre': 'Exzellenz',
  'apropos.valeurs.excellence.texte': 'Mir maache ni Kompromësser bei der Qualitéit. All Detail zielt, vum Design bis zur Veraarbechtung vum Puzzle.',
  'apropos.valeurs.creativite.titre': 'Kreativitéit',
  'apropos.valeurs.creativite.texte': 'Mir erfannen ëmmer erëm eppes Neies, fir eenzegaarteg an onvergiesslech Uskënnegungen ze schafen, déi ee sech mierkt.',
  'apropos.valeurs.authenticite.titre': 'Authentizitéit',
  'apropos.valeurs.authenticite.texte': 'Mir bleiwen eise Wäerter trei an eisem Engagement fir eis Cliente an eis Communautéit.',
  'apropos.valeurs.innovation.titre': 'Innovatioun',
  'apropos.valeurs.innovation.texte': 'Mir sichen dauernd nei Weeër, fir aussergewéinlech Feierlechkeeten ze schafen.',
  'apropos.valeurs.emotions.titre': 'Emotiounen',
  'apropos.valeurs.emotions.texte': 'Mir schafe Momenter voller Emotioun, déi der ganzer Famill an Erënnerung bleiwen.',
  'apropos.valeurs.passion.titre': 'Passioun',
  'apropos.valeurs.passion.texte': 'Mir si passionéiert vun deem, wat mir maachen, an dat spiert een an all Produit.',
  'apropos.reseaux.titre': 'Eis sozial Netzwierker',
  'apropos.reseaux.soustitre': 'Kommt an eis Communautéit a kuckt hannert d’Kulissen',
  'apropos.reseaux.instagram.texte': 'Entdeckt eis lescht Kreatiounen, kuckt hannert d’Kulisse vun eise Puzzlen an deelt Är magesch Momenter mat #MirumGames',
  'apropos.reseaux.facebook.texte': 'Kommt an eis Communautéit, maacht bei de Concoursen a bleift iwwer eis exklusiv Offeren an Neiegkeeten um Lafenden',
  'apropos.processus.titre': 'Eise Kreatiounsprozess',
  'apropos.processus.soustitre': 'Vun der Iddi bis bei Iech heem',
  'apropos.processus.etape1.titre': 'Recherche & Iddien',
  'apropos.processus.etape1.texte': 'Mir lauschteren op d’Retoure vun zukünftegen Elteren a vu Leit, déi eng Gender-Reveal-Feier organiséieren, fir Erliefnesser ze schafen, déi nach besser an Erënnerung bleiwen.',
  'apropos.processus.etape2.titre': 'Konzeptioun & Tester',
  'apropos.processus.etape2.texte': 'Eist Team entwërft all Puzzle an testt alles grëndlech, sou datt d’Spill lëschteg bleift an de Moment ee bleift, deen een net vergësst.',
  'apropos.processus.etape3.titre': 'Fabrikatioun',
  'apropos.processus.etape3.texte': 'All Puzzle gëtt mat Suergfalt an Ae fir den Detail hiergestallt, fir eng Premium-Qualitéit.',
  'apropos.processus.etape4.titre': 'Qualitéit & Versand',
  'apropos.processus.etape4.texte': 'All Spill leeft duerch eng streng Qualitéitskontroll, ier et suergfälteg bei Iech geschéckt gëtt.',
  'apropos.cta.titre': 'Prett, eis Spiller z’entdecken?',
  'apropos.cta.texte': 'Entdeckt eis komplett Kollektioun a maacht aus der Uskënnegung vum Geschlecht vun Ärem Bëbee e mageschen an onvergiessleche Moment.',
  'apropos.cta.boutique': '🛍️ De Shop entdecken',
  'apropos.cta.contact': '💬 Kontaktéiert eis',

  // ---- Kontakt (pages/Contact.jsx) ----
  'contact.seo.titre': 'Kontakt',
  'contact.seo.description': 'Kontaktéier Mirum Games mat all denge Froen iwwer Joyful Reveal, eist Spill, oder iwwer deng Bestellungen. Séier Äntwert garantéiert.',
  'contact.hero.badge': '💬 Bleiwe mir a Kontakt',
  'contact.hero.titre': 'Mir héieren gär vun Iech',
  'contact.hero.texte': 'Froen? Virschléi? Zéckt net, eis ze kontaktéieren. Mir äntweren normalerweis bannent 24 Stonnen.',
  'contact.cartes.email.titre': 'E-Mail',
  'contact.cartes.email.texte': 'Äntwert bannent 24-48 St.',
  'contact.cartes.adresse.titre': 'Adress',
  'contact.cartes.adresse.ligne1': 'Rue de la Cortaille, 59',
  'contact.cartes.adresse.ligne2': '6800 Freux, Belsch',
  'contact.cartes.faq.titre': 'Froen?',
  'contact.cartes.faq.texte': 'Kuckt eis FAQ',
  'contact.cartes.faq.soustexte': 'Direkt eng Äntwert',
  'contact.formulaire.titre': 'Schéckt eis eng Noriicht',
  'contact.formulaire.nom': 'Ären Numm',
  'contact.formulaire.nomPlaceholder': 'Jos Schmit',
  'contact.formulaire.email': 'E-Mail',
  'contact.formulaire.emailPlaceholder': 'aer@email.com',
  'contact.formulaire.sujet': 'Sujet',
  'contact.formulaire.sujetPlaceholder': '-- Wielt e Sujet --',
  'contact.formulaire.sujetCommande': 'Fro iwwer meng Bestellung',
  'contact.formulaire.sujetProduit': 'Fro iwwer e Produit',
  'contact.formulaire.sujetLivraison': 'Fro iwwer d’Liwwerung',
  'contact.formulaire.sujetPartenariat': 'Partnerschaft',
  'contact.formulaire.sujetAutre': 'Anescht',
  'contact.formulaire.message': 'Noriicht',
  'contact.formulaire.messagePlaceholder': 'Är Noriicht hei...',
  'contact.formulaire.envoiEnCours': '⏳ Gëtt geschéckt...',
  'contact.formulaire.envoyer': '📬 D’Noriicht schécken',
  'contact.formulaire.succes': '✨ Merci fir Är Noriicht! Mir äntweren Iech ganz séier.',
  'contact.faq.titre': 'Dacks gestallte Froen',
  'contact.faq.soustitre': 'Vläicht steet Är Äntwert scho hei',
  'contact.faq.q1': '❓ Wéi laang dauert d’Liwwerung?',
  'contact.faq.a1': "D’Bestellunge ginn am Duerchschnëtt bannent engem Aarbechtsdag aus der Belsch verschéckt. Duerno rechent mat 1 bis 2 Aarbechtsdeeg fir Lëtzebuerg, d’Belsch an d’Nidderlanden, 2 bis 4 Deeg fir Frankräich an Däitschland an 4 bis 5 Deeg fir Spuenien.",
  'contact.faq.q2': '🎁 Kann ech eng perséinlech Noriicht derbäisetzen?',
  'contact.faq.a2': 'Natierlech! Eis Premium-Packen enthalen eng perséinlech Kaart. Kontaktéiert eis no Ärer Bestellung fir d’Detailer.',
  'contact.faq.q3': '💰 Hutt Dir eng Garantie?',
  'contact.faq.a3': 'Jo! Dir hutt 14 Deeg Zäit, fir e Produit zréckzeschécken, deen Iech net passt. Ausserdeem gi mir op all eis Produiten eng Garantie géint verstoppte Mängel.',
  'contact.faq.q4': '🌍 Liwwert Dir och an d’Ausland?',
  'contact.faq.a4': "Mir liwweren an d’Belsch, a Frankräich, a Lëtzebuerg, an d’Nidderlanden, an Däitschland an a Spuenien. Bei der Bestellung wielt Dir tëscht der Liwwerung heem an engem Ofhuelpunkt, jee no de Spediteuren, déi op Ärer Adress disponibel sinn.",
  'contact.faq.q5': '🎮 Wéi funktionéiert de Puzzle?',
  'contact.faq.a5': 'Et ass e lëschtegt Fro-Äntwert-Spill, dat Iech duerch de Puzzle féiert. Bei all richteger Äntwert leet Dir Stécker derbäi an entdeckt um Enn d’Geschlecht vum Bëbee!',
  'contact.faq.q6': '🎊 Mat wéi vill Leit kann ee spillen?',
  'contact.faq.a6': 'De Puzzle ass gemaach, fir an der Famill zesummen ze spillen! Dir kënnt Equipe bilden a mat méi Leit spillen, fir de Moment nach méi festlech ze maachen.',
  'contact.newsletter.titre': 'Bleift um Lafenden',
  'contact.newsletter.texte': 'Schreift Iech an eise Newsletter an, fir déi lescht Offeren an Neiegkeeten ze kréien',
  'contact.newsletter.emailPlaceholder': 'aer@email.com',
  'contact.newsletter.inscrire': 'Aschreiwen',
  'contact.newsletter.succes': '✨ Wëllkomm an eisem Newsletter!',

  // ---- Clientsmeenungen (components/Reviews/*) ----
  // Den INHALT vun de Meenungen (Text, Titel, Numm vum Auteur) kënnt aus der
  // Datebank a gëtt ni iwwersat; nëmmen de Kader leeft iwwer dës Schlësselen.
  'avis.section.badge': '💬 Erfarunge vu Clienten',
  'avis.section.titre': 'Wat eis Cliente begeeschtert',
  'avis.section.accrocheAucun': 'Schonn gespillt? Erzielt eis vun Ärem Moment — Är Meenung hëlleft den nächsten zukünftegen Elteren bei hirer Entscheedung.',
  'avis.section.accrochePeu': 'Si hu virun Iech gespillt an hu sech d’Zäit geholl, fir eis ze schreiwen. Hei sinn hir Wierder, ongefiltert.',
  'avis.section.accrocheNombreux': 'Schonn {n} Familljen hunn hire Moment mat eis gedeelt.',
  'avis.section.compteurSingulier': 'Meenung',
  'avis.section.compteurPluriel': 'Meenungen',
  'avis.section.premierAvis': 'Gitt déi éischt Persoun, déi hir Meenung deelt!',
  'avis.section.fermer': '✕ Zoumaachen',
  'avis.section.laisserAvis': '✍️ Eng Meenung hannerloossen',
  'avis.section.chargement': 'Meenunge ginn gelueden...',
  'avis.section.listeTitre': 'D’Meenungen',
  'avis.section.aucunTitre': 'Sidd déi éischt!',
  'avis.section.aucunTexte': 'Nach keng Meenung. Deelt als éischt Är magesch Erfarung!',
  'avis.section.ecrirePremier': 'Déi éischt Meenung schreiwen',
  'avis.section.erreurEnvoi': 'Feeler beim Schécke vun der Meenung',
  'avis.carte.noteAria': 'Note vu {note} op 5',
  'avis.carte.clientVerifie': 'Verifizéierte Client',
  'avis.carte.achatVerifie': '✅ Verifizéierte Kaf',
  'avis.formulaire.titre': 'Deelt Är Erfarung',
  'avis.formulaire.note': 'Gesamtnote',
  'avis.formulaire.noterAria': '{n} Stäre ginn',
  'avis.formulaire.note5': 'Exzellent! 🤩',
  'avis.formulaire.note4': 'Ganz gutt 🙂',
  'avis.formulaire.note3': 'Gutt 😐',
  'avis.formulaire.note2': 'Mëttelméisseg 😕',
  'avis.formulaire.note1': 'Enttäuscht 😞',
  'avis.formulaire.titreAvis': 'Titel vun Ärer Meenung',
  'avis.formulaire.titrePlaceholder': 'Bsp.: Super Puzzle, meng Duechter ass begeeschtert!',
  'avis.formulaire.commentaire': 'Äre Kommentar',
  'avis.formulaire.commentairePlaceholder': 'Sot eis, wat Iech gefall huet...',
  'avis.formulaire.envoiEnCours': 'Gëtt geschéckt...',
  'avis.formulaire.publier': 'Meng Meenung verëffentlechen',

  // ---- Cookie-Banner (components/CookieConsent.jsx) ----
  'cookies.bandeau.titre': '🍪 Cookie-Gestioun',
  'cookies.bandeau.texte': "Dëse Site benotzt nëmmen zwou Saachen: d'Cookien, déi Äre Kuerf an Är Umeldung brauchen, an eng anonym Publikumsmiessung, déi mir selwer maachen — ouni Cookie an ouni Iech jeemools z'identifizéieren. Keng Reklamm, kee Profiling, näischt gëtt un en Drëtten weiderginn.",
  'cookies.gerer': "Meng Cookien verwalten",
  'cookies.categories.necessaires': 'Néideg Cookien',
  'cookies.categories.necessairesDesc': 'Ëmmer aktiv - Essentiell fir d’Funktionéiere vum Site',
  'cookies.categories.analytics': "Anonym Publikumsmiessung",
  'cookies.categories.analyticsDesc': "Zuel vun de Visitten an de consultéierte Säiten. Ouni Cookie, ouni Identifikant, Är IP-Adress gëtt ni gespäichert. Dir kënnt se refuséieren.",
  'cookies.categories.marketing': 'Marketing-Cookien',
  'cookies.categories.marketingDesc': 'Fir Iech perséinlech ugepassten Inhalt an Offeren ze weisen',
  'cookies.bandeau.voirNotre': 'Kuckt eis',
  'cookies.bandeau.politique': 'Dateschutzerklärung',
  'cookies.bandeau.plusInfos': 'fir méi Informatiounen',
  'cookies.actions.refuser': 'Alles refuséieren',
  'cookies.actions.personnaliser': 'Upassen',
  'cookies.actions.accepter': 'Alles akzeptéieren',

  // --- Connexion, inscription, profil ---
  // Ces trois pages n'etaient pas traduites du tout : un visiteur allemand
  // cliquait « Anmelden » dans une barre de navigation allemande et recevait
  // un formulaire entierement francais.
  'compte.connexion.seoTitre': "Aloggen",
  'compte.connexion.seoDescription': "Loggt Iech an Ären Mirum-Games-Kont an.",
  'compte.connexion.titre': "Aloggen",
  'compte.connexion.sousTitre': "Wëllkomm bei Mirum Games",
  'compte.champ.email': "E-Mail-Adress",
  'compte.champ.emailPlaceholder': "aer@email.com",
  'compte.champ.motDePasse': "Passwuert",
  'compte.champ.motDePassePlaceholder': "Äert Passwuert",
  'compte.champ.basculerMotDePasse': "Passwuert weisen oder verstoppen",
  'compte.connexion.seSouvenir': "Ugemellt bleiwen",
  'compte.connexion.motDePasseOublie': "🔑 Passwuert vergiess?",
  'compte.connexion.bouton': "🔓 Aloggen",
  'compte.connexion.enCours': "⏳ Umeldung leeft…",
  'compte.connexion.ouContinuerAvec': "Oder weider mat",
  'compte.connexion.pasDeCompte': "Nach kee Kont?",
  'compte.connexion.creerUnCompte': "E Kont uleeën",
  'compte.connexion.erreur': "Ongëlteg Umeldungsdonnéeën. Probéiert et w.e.g. nach eng Kéier.",
  'compte.connexion.erreurGoogle': "Bei der Umeldung mat Google ass e Feeler opgetrueden.",
  'compte.inscription.seoTitre': "Umellen",
  'compte.inscription.seoDescription': "Leet Ären Mirum-Games-Kont un.",
  'compte.inscription.titre': "Umellen",
  'compte.inscription.sousTitre': "Maacht mat bei der Mirum-Games-Gemeinschaft",
  'compte.champ.nomComplet': "Kompletten Numm",
  'compte.champ.nomCompletPlaceholder': "Jean Weber",
  'compte.champ.creerMotDePasse': "Wielt e séchert Passwuert",
  'compte.champ.confirmation': "Passwuert bestätegen",
  'compte.champ.confirmationPlaceholder': "Bestätegt Äert Passwuert",
  'compte.force.faible': "❌ Schwaach",
  'compte.force.moyen': "⚠️ Mëttel",
  'compte.force.fort': "✅ Staark",
  'compte.inscription.accepteLes': "Ech akzeptéieren déi",
  'compte.inscription.conditions': "allgemeng Verkafsbedingungen",
  'compte.inscription.etLa': "an d’",
  'compte.inscription.politique': "Dateschutzerklärung",
  'compte.inscription.bouton': "🎮 E Kont uleeën",
  'compte.inscription.enCours': "⏳ De Kont gëtt ugeluecht…",
  'compte.inscription.dejaUnCompte': "Hutt Dir schonn e Kont?",
  'compte.inscription.seConnecter': "Aloggen",
  'compte.inscription.erreurMotsDePasse': "D’Passwierder stëmmen net iwwereneen.",
  'compte.inscription.erreurConditions': "Akzeptéiert w.e.g. d’Notzungsbedingungen.",
  'compte.inscription.erreurLongueur': "D’Passwuert muss op mannst 6 Zeeche laang sinn.",
  'compte.inscription.erreur': "Bei der Umeldung ass e Feeler opgetrueden. Probéiert et w.e.g. nach eng Kéier.",
  'compte.profil.deconnexion': "Ausloggen",
  'compte.profil.mesCommandes': "📦 Meng Bestellungen",
  'compte.profil.informations': "👤 Donnéeën",
  'compte.profil.informationsTitre': "Perséinlech Donnéeën",
  'compte.commandes.chargement': "Bestellunge ginn gelueden…",
  'compte.commandes.aucune': "Dir hutt nach keng Bestellung opginn.",
  'compte.commandes.decouvrir': "Eis Produkter entdecken",
  'compte.commandes.articles': "Artikelen:",
  'compte.commandes.total': "Total:",
  'compte.commandes.suiviLabel': "Verfollegungsnr.:",
  'compte.commandes.suivre': "Mäi Pak verfollegen",
  'compte.commandes.facture': "Rechnung eroflueden",
  "compte.commandes.noteCredit": "Gutschrëft",
  'compte.commandes.avis': "Eng Meenung hannerloossen",
  'compte.commandes.nonAuthentifie': "Är Sitzung ass ofgelaf. Loggt Iech w.e.g. nach eng Kéier an.",
  'compte.commandes.erreur': "Beim Luede vun Äre Bestellungen ass e Feeler opgetrueden",
  'compte.statut.paid': "Bezuelt",
  'compte.statut.shipped': "Verschéckt",
  'compte.statut.delivered': "Geliwwert",
  'compte.statut.cancelled': "Annuléiert",
  'compte.infos.general': "Allgemeng Donnéeën",
  'compte.infos.nomComplet': "Kompletten Numm *",
  'compte.infos.emailFige': "D’E-Mail-Adress kann net geännert ginn",
  'compte.infos.adresseLivraison': "Liwweradress",
  'compte.infos.adresse': "Adress",
  'compte.infos.adressePlaceholder': "Strooss an Hausnummer",
  'compte.infos.ville': "Uertschaft",
  'compte.infos.codePostal': "Postleetzuel",
  'compte.infos.pays': "Land",
  'compte.infos.choisirPays': "E Land wielen",
  'compte.infos.telephone': "Telefon",
  'compte.infos.enregistrer': "💾 Späicheren",
  'compte.infos.enregistrement': "⏳ Gëtt gespäichert…",
  'compte.infos.succes': "✅ Äre Profil gouf aktualiséiert.",
  'compte.infos.erreur': "❌ Beim Aktualiséiere vun Ärem Profil ass e Feeler opgetrueden",
  "maFacture.seoTitre": "Meng Rechnung erëmfannen - Mirum Games",
  "maFacture.seoDescription": "Fannt d'Rechnung vun Ärer Mirum-Games-Bestellung mat Ärer Bestellnummer an Ärer E-Mail-Adress erëm.",
  "maFacture.titre": "Meng Rechnung erëmfannen",
  "maFacture.intro": "Dir hutt ouni Kont bestallt a fannt d'Confirmatiouns-E-Mail net méi? Gitt Är Bestellnummer an d'E-Mail-Adress un, déi Dir beim Kaf benotzt hutt.",
  "maFacture.champNumero": "Bestell- oder Rechnungsnummer",
  "maFacture.champNumeroAide": "Si steet an der Confirmatiouns-E-Mail an op der Säit, déi no der Bezuelung ugewise gouf.",
  "maFacture.champEmail": "E-Mail-Adress, déi beim Kaf benotzt gouf",
  "maFacture.bouton": "Meng Rechnung erëmfannen",
  "maFacture.recherche": "Sichen…",
  "maFacture.introuvable": "Mir fannen keng Bestellung mat dësen Donnéeën. Kontrolléiert d'Nummer an d'E-Mail-Adress, déi Dir beim Kaf benotzt hutt.",
  "maFacture.tropDEssais": "Ze vill Versich hannerteneen. Waart w.e.g. eng Minutt a probéiert et dann nach eng Kéier.",
  "maFacture.erreur": "D'Sich huet net geklappt. Probéiert et gläich nach eng Kéier oder schreift eis.",
  "maFacture.facture": "Är Rechnung Nr. {numero} ass prett.",
  "maFacture.voirFacture": "🧾 Rechnung kucken an drécken",
  "maFacture.langueDocument": "D'Rechnung ass op Franséisch. Dir kënnt se an Ärem Browser drécken oder als PDF späicheren.",
  "maFacture.factureStripe": "🧾 Rechnung vun dëser Bestellung kucken",
  "maFacture.enAttente": "Är Bezuelung ass nach net ukomm: Mir schécken Iech d'Rechnung per E-Mail, soubal se do ass.",
  "maFacture.aucune": "Fir dës Bestellung gëtt et keng Online-Rechnung. Schreift eis, mir schécken se Iech.",
  "maFacture.voirNote": "Gutschrëft Nr. {numero}",
  "maFacture.compte": "Dir hutt e Kont? All Är Rechnungen fannt Dir ënner",
};
